import React, { useState } from 'react';
import './LinkedInPosts.css';
import useLinkedInPosts from '../hooks/useLinkedInPosts';

const LINKEDIN_PROFILE_URL = 'https://www.linkedin.com/in/texus/';
const INITIAL_VISIBLE_POSTS = 6;

function LinkedInIcon() {
  return (
    <svg
      className="linkedin-icon-li"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.55V9h3.57v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z" />
    </svg>
  );
}

function LinkedInPosts() {
  const { posts, loading, error } = useLinkedInPosts();
  const [showAll, setShowAll] = useState(false);

  if (loading) {
    return (
      <div className="linkedin-section-li">
        <div className="linkedin-loading-li">
          <div className="linkedin-spinner-li"></div>
          <p>Loading LinkedIn posts...</p>
        </div>
      </div>
    );
  }

  // Secondary content: stay out of the way when unavailable
  if (error || posts.length === 0) {
    return null;
  }

  const visiblePosts = showAll ? posts : posts.slice(0, INITIAL_VISIBLE_POSTS);

  return (
    <div className="linkedin-section-li">
      <div className="linkedin-header-li">
        <h2 className="linkedin-title-li">
          <LinkedInIcon />
          From LinkedIn
        </h2>
        <a
          href={LINKEDIN_PROFILE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="linkedin-profile-link-li"
        >
          Follow TExUS Lab
        </a>
      </div>

      <div className="linkedin-cards-grid-li">
        {visiblePosts.map((post) => (
          <a
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin-card-link-li"
            key={post.id || post.linkedinId}
          >
            <div className="linkedin-card-li">
              {post.image && (
                <div className="linkedin-card-image-li">
                  <img src={post.image} alt={post.title} />
                </div>
              )}
              <div className="linkedin-card-content-li">
                <p className="linkedin-card-date-li">{post.date}</p>
                <h3 className="linkedin-card-title-li">{post.title}</h3>
                <p className="linkedin-card-text-li">{post.content}</p>
                <span className="linkedin-card-cta-li">Read on LinkedIn →</span>
              </div>
            </div>
          </a>
        ))}
      </div>

      {posts.length > INITIAL_VISIBLE_POSTS && (
        <button
          className="linkedin-toggle-li"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? 'Show less' : `Show all ${posts.length} posts`}
        </button>
      )}
    </div>
  );
}

export default LinkedInPosts;
